let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3XVDp")).then(() => parcelRequire('iSxaX'));